export default __webpack_public_path__ + "static/media/test.7736ab9a.svg";